import ChatBotMessageLogo from "../../../assets/images/svg/chat-bot-message-logo.svg";

export const BotMessage = ({ message, timestamp }) => {
  return (
    <div className="bot-message">
      <div className="message-bubble">
        <p className="mb-0">{message}</p>
      </div>
      <div className="message-tail"></div>
      <img src={ChatBotMessageLogo} className="avatar" alt="Bot" />
      {timestamp && <span className="timestamp">{timestamp}</span>}
    </div>
  );
};
